/* D7 Supply — case-pack minimum quantity enforcement.
 * Only inputs rendered with data-d7-min (products carrying metafield custom.min_qty) are touched.
 * Product page / quick view / sticky bar: quantity is forced to the minimum (data-d7-min) and then up to the next
 * allowed step (data-d7-step: equal to the minimum for case packs, 1 for "minimum only" products) before add-to-cart.
 * Cart page / cart drawer: typed quantities are corrected the same way; 0 still removes the line.
 */
(function () {
  function caseSize(input) {
    var m = parseInt(input.getAttribute('data-d7-min'), 10);
    return m > 1 ? m : 0;
  }
  function isCartLine(input) {
    return input.name === 'updates[]';
  }
  function maxQty(input) {
    var x = parseInt(input.getAttribute('data-d7-max'), 10);
    return x > 0 ? x : 0;
  }
  function stepSize(input) {
    var s = parseInt(input.getAttribute('data-d7-step'), 10);
    return s > 0 ? s : caseSize(input);
  }
  // smallest allowed quantity that is >= v: the minimum, then whole steps above it
  function roundUp(v, m, s) {
    if (v <= m) return m;
    return m + Math.ceil((v - m) / s) * s;
  }
  // Units of this variant already in the cart (the theme keeps data-cart-quantity current).
  function inCart(input) {
    var c = parseInt(input.getAttribute('data-cart-quantity'), 10);
    return c > 0 ? c : 0;
  }
  function normalize(input) {
    var m = caseSize(input);
    if (!m) return false;
    var s = stepSize(input);
    // "Minimum only" products: once the minimum is already in the cart, any extra quantity is fine
    // (and if part of it is in the cart, only the shortfall is required).
    if (s === 1 && !isCartLine(input)) {
      var have = inCart(input);
      m = Math.max(1, m - have);
    }
    var v = parseInt(input.value, 10);
    if (isNaN(v)) v = m;
    if (v <= 0) {
      if (isCartLine(input)) return false; // 0 in the cart = remove line, leave it alone
      v = m;
    }
    var fixed = roundUp(v, m, s);
    var mx = maxQty(input);
    if (mx && fixed > mx) fixed = mx; // never above what is in stock (whole cases, or the final lot)
    if (String(fixed) !== String(input.value)) {
      input.value = fixed;
      return true;
    }
    return false;
  }
  function flash(input) {
    var m = caseSize(input);
    var host = input.closest('quantity-input') || input.parentElement;
    var anchor = host && host.parentElement ? host.parentElement : host;
    if (!anchor) return;
    var msg = anchor.querySelector('.d7-qty-msg');
    if (!msg) {
      msg = document.createElement('div');
      msg.className = 'd7-qty-msg text-sm';
      msg.style.cssText = 'color:#b45309;margin-top:4px;flex-basis:100%;';
      anchor.appendChild(msg);
    }
    var mx = maxQty(input);
    var lot = mx && mx === m; // final-lot mode: only the remaining units can be bought
    var minOnly = stepSize(input) === 1;
    msg.textContent = lot
      ? 'Only ' + m + ' left — sold together as one lot.'
      : (mx && parseInt(input.value, 10) >= mx ? 'Only ' + mx + ' in stock — quantity set to ' + input.value + '.'
          : minOnly ? 'Minimum order is ' + m + ' — quantity set to ' + input.value + '.'
                    : 'Sold in cases of ' + m + ' — quantity set to ' + input.value + '.');
    clearTimeout(msg._t);
    msg._t = setTimeout(function () { msg.remove(); }, 4000);
  }

  // Runs in the capture phase, i.e. before the theme's own change handlers read the value.
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!(el instanceof HTMLInputElement) || !el.hasAttribute('data-d7-min')) return;
    if (normalize(el)) flash(el);
  }, true);

  // Guard the add-to-cart submit (product page, quick view, sticky bar).
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return;
    var q = form.querySelector('input[name="quantity"]');
    if (!q && form.id) q = document.querySelector('input[name="quantity"][form="' + form.id + '"]');
    if (!q || !q.hasAttribute('data-d7-min')) return;
    if (normalize(q)) flash(q);
  }, true);

  // Existing cart lines that are below / off a case (e.g. carts created before this rule) get corrected once rendered.
  function fixCartLines() {
    document.querySelectorAll('input[name="updates[]"][data-d7-min]').forEach(function (input) {
      var v = parseInt(input.value, 10);
      var m = caseSize(input);
      var mx = maxQty(input);
      var st = stepSize(input);
      var ok = v >= m && (v - m) % st === 0 && (!mx || v <= mx);
      if (!m || isNaN(v) || v <= 0 || ok) return;
      if (input.dataset.d7Fixing) return;
      input.dataset.d7Fixing = '1';
      var fixed = roundUp(v, m, st);
      if (mx && fixed > mx) fixed = mx;
      input.value = fixed;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(fixCartLines, 300); });
  } else {
    setTimeout(fixCartLines, 300);
  }
  document.addEventListener('cart:updated', function () { setTimeout(fixCartLines, 300); });
  document.addEventListener('cart-drawer:open', function () { setTimeout(fixCartLines, 300); });
})();
